export default Object.freeze([
  'ADMIN',
  'USER',
])
